<template>
  <div>
    <el-dialog
      width="632px"
      :visible="dialogVisible"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div slot="title">
        <div class="el-dialog__title">
          {{ $t('PublishTemplateDialog_Title') }}
        </div>
      </div>
      <div class="items-container">
        <!-- Added a v-if in publish-template-form due to an element-ui bug that causes the dialog to
             re-render in the background instead of being destroyed when you close the dialog -->
        <publish-template-form
          v-if="dialogVisible"
          ref="publish-template-form"
          :campaign-model="campaignModel"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">
          <i class="el-icon-check el-icon--left" />
          <span>{{ $t('PublishTemplateDialog_PublishBtn') }}</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PublishTemplateForm from '@/modules/campaigns/components/PublishTemplateForm.vue'
export default {
  name: 'PublishTemplateDialog',
  components: {
    PublishTemplateForm
  },
  props: {
    dialogVisible: {
      type: Boolean,
      required: true
    },
    campaignModel: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClose() {
      this.$refs['publish-template-form'].resetForm()
      this.$emit('update:dialogVisible', false)
    },
    save() {
      this.$refs['publish-template-form'].save()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/PublishTemplateDialog.vue